import React, {useState, useCallback} from 'react'
import { navigate } from 'gatsby'
import SearchBtn from '../icons/SearchBtn'
import { StaticImage } from 'gatsby-plugin-image'
import './postcodecta.scss'

/* global _paq */


const PostcodeCTAInput = ({ targetPath = '/liveincare/looking-for-care/' }) => {
    const [postcodeInput, setPostcodeInput] = useState('')
    const searchPostcode = useCallback(() => {
		const trimmedPostcode = postcodeInput.trim()
		if (!trimmedPostcode) return

        if (typeof _paq !== 'undefined') {
            _paq && _paq.push(['trackEvent', 'PostcodeCta', 'Submit', trimmedPostcode]);

        }
        const search = new URLSearchParams(document.location.search)
		search.set('postcode', trimmedPostcode)
		navigate(`${targetPath}?${search.toString()}`)
    }, [postcodeInput, targetPath])



    return (
        <div className="input-wrapper">
            <input
                className=""
                type="text"
                id="postalcode"
                name="postcode"
                placeholder="Enter your postcode"
				required
                value={postcodeInput}
                onChange={e => {
                    setPostcodeInput(e.target.value)
                }}
                onKeyUp={e => {
                    if (e.key === 'Enter') searchPostcode()
                }}
            />
            <button
				aria-label="Check care in your area"
				className="search-btn-wrapper"
				onClick={()=>searchPostcode()}
				type="button"
			>
                <div className="search-btn">
                    <SearchBtn/>
                </div>
			</button>
        </div>

    )
}

const PostcodeCTA = ({
    className = "",
    title = "Start your care journey today:",
    ctaHref = "",
    ctaLabel = ""
}) => {
    const useButtonCta = Boolean(ctaHref && ctaLabel)
    return(
        <div className={`postcode-cta ${className}`}>
            <div className="postcode-top">
                <div className="postcode-form">
                    <p className="title">{title}</p>
                    {useButtonCta ? (
                        <a href={ctaHref} className="postcode-cta-button">{ctaLabel}</a>
                    ) : (
                        <PostcodeCTAInput />
                    )}
                </div>
            </div>
            <div className="postcode-footer">
                <div className="call-us">
                    <StaticImage placeholder="blurred"
                        src="../../../static/assets/marketing-site/images/postcode-img.png"
                        alt="advisors-img"
                        objectFit="contain"
                    />
                    <div className="call-us-details">
                        <div className="secondary">Or call us today on:</div>
                        <a href="tel:020 3970 9900" className="number">020 3970 9900</a>
                    </div>
                </div>
            </div>
        </div>				
    )
}

export { PostcodeCTA, PostcodeCTAInput };
